import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { useFetch, NeedTenant } from "../hooks/useData";
import { GlassCard, Loading, EmptyState, SectionTitle } from "../components/common";
import ProcessMap from "../components/ProcessMap";
import { GitBranch, Activity, Hash, Play, Flag } from "lucide-react";

function Inner() {
  const { datasetId, currentDataset } = useApp();
  const { data, loading } = useFetch(datasetId ? `/datasets/${datasetId}/process-map` : null, { skip: !datasetId });
  const [metric, setMetric] = useState("frequency");

  if (!datasetId) return <EmptyState icon={GitBranch} title="No dataset selected" sub="Pick a dataset from the top bar to discover its process map." />;
  if (loading) return <Loading label="Discovering process model…" />;
  if (!data) return null;

  return (
    <div className="space-y-5 pm-fade-up">
      <SectionTitle eyebrow="Auto-discovered Model" title="Process Map"
        sub={`${currentDataset?.name} · ${data.nodes.length} activities · ${data.edges.length} paths`}
        right={
          <div className="glass rounded-xl p-1 flex gap-1">
            {[["frequency", "Frequency", Hash], ["performance", "Performance", Activity]].map(([v, l, Icon]) => (
              <button key={v} onClick={() => setMetric(v)} data-testid={`metric-${v}`}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium pm-transition ${metric === v ? "pm-gradient text-white" : "text-slate-500 hover:text-slate-800"}`}>
                <Icon className="w-3.5 h-3.5" />{l}
              </button>
            ))}
          </div>
        } />
      <GlassCard className="p-4">
        <div className="flex items-center gap-5 mb-3 text-xs text-slate-500 px-2">
          <span className="flex items-center gap-1.5"><Play className="w-3 h-3 text-emerald-500" />Start</span>
          <span className="flex items-center gap-1.5"><Flag className="w-3 h-3 text-indigo-500" />End</span>
          <span className="flex items-center gap-1.5"><span className="w-4 h-0.5 bg-cyan-600" />Path (thickness = volume)</span>
          {metric === "performance" && <span className="flex items-center gap-1.5"><span className="w-4 h-0.5 bg-amber-500" />Bottleneck &gt;40h</span>}
        </div>
        <ProcessMap data={data} metric={metric} />
      </GlassCard>
    </div>
  );
}

export default function ProcessMapPage() { return <NeedTenant><Inner /></NeedTenant>; }
